module.exports = __webpack_public_path__ + "fonts/Lato-Regular.122dd68d.ttf";